import React, { Component } from "react";
import { Row, Col, Layout, Button } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { API_URL } from "../../config";
const { Footer } = Layout;

class ErrorNotFoundPage extends Component {
  render() {
    return (
      <>
        <section className="tv-404-animation">
          <div className="error-container">
            <Row gutter={"xs: 8, sm: 16, md: 24"}>
              <Col md={12} className="tv-title">
                <h2 className="tv-title-404-tm">Oops! Something went wrong.</h2>
                <p className="tv-text-404-tm">
                  The page you are looking for does not exist or has changed
                </p>
                <Button type="primary">
                  <a href={API_URL}>
                    back to home page
                    <RightOutlined />
                  </a>
                </Button>
              </Col>
              <Col md={12} className="tv-title">
                <svg
                  id="isometric"
                  width="1302"
                  height="952"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 1302 952"
                >
                  <path
                    fill="#043650"
                    d="M819.932 810.526l-4.83 24.13 3.096 7.956 15 4.043 15-1.758 10.847-10.597 5.82-14.98-12.334-16"
                  />
                  <path fill="#EA0000" d="M526.864 209.988h1v238h-1z" />
                  <path
                    fill="#2760f2"
                    d="M377.864 406.988h-1v-59.924l-56.184 32.243-.498-.867 57.682-33.102z"
                  />
                  <path
                    fill="#CCC"
                    d="M354.425 839.054l-33.704-19.5 61.69-34.628 33.705 18.845z"
                  />
                  <path
                    fill="#B3B3B3"
                    d="M354.518 838.997l-33.69-19.43-.214.046v81.43l33.904 19.478z"
                  />
                  <path
                    fill="#4C4C4C"
                    d="M354.393 860.96l-33.606-19.382-.12.026-.106-.488.31-.067.083.046 33.69 19.43zM354.393 881.707l-33.606-19.382-.12.025-.105-.488.308-.066.083.048 33.69 19.43zM354.393 902.454l-33.606-19.382-.12.025-.105-.488.308-.067.083.048 33.69 19.43z"
                  />
                  <path
                    fill="#4C4C4C"
                    d="M354.007 838.997l62.065-35.528.086.045v81.43l-62.15 35.576z"
                  />
                  <ellipse
                    transform="rotate(58.807 335.6 850.116)"
                    fill="#EA0000"
                    cx="335.589"
                    cy="850.086"
                    rx="3.542"
                    ry="2.03"
                  />
                  <path
                    fill="#CCC"
                    d="M408.09 871.422l-33.704-19.502 61.69-34.627 33.704 18.845z"
                  />
                  <path
                    fill="#B3B3B3"
                    d="M408.183 871.364l-33.69-19.43-.214.047v81.432l33.903 19.477z"
                  />
                  <path
                    fill="#4C4C4C"
                    d="M408.058 893.328l-33.606-19.382-.12.025-.105-.487.308-.066.083.048 33.69 19.43zM408.058 914.074l-33.606-19.382-.12.027-.106-.49.308-.067.084.048 33.69 19.43zM408.058 934.82l-33.606-19.38-.12.025-.105-.49.308-.065.083.048 33.69 19.43z"
                  />
                  <path
                    fill="#4C4C4C"
                    d="M407.672 871.364l62.065-35.527.086.046v81.43l-62.15 35.576z"
                  />
                  <path
                    fill="#EA0000"
                    d="M335.864 852.988h-1V715.124l.75.43 113.916 65.44 45.647-26.44.5.867-46.145 26.73-113.668-65.298z"
                  />
                  <path
                    fill="#FFF"
                    d="M883.228 801.18l-.504-.863 265.14-154.616V632.99h1v13.287l-.248.145z"
                  />
                  <path
                    fill="#2760f2"
                    d="M278.228 498.18l-.504-.863L542.864 342.7V197.99h1v145.287l-.248.145z"
                  />
                  <path
                    fill="#0a64d3"
                    d="M628.4 818.948L246.988 600.552 628.4 385.532l381.413 215.02z"
                  />
                  <path
                    fill="#028cc5"
                    d="M629.352 818.576l-381.14-218.1-.4.087V617.7l381.54 218.188z"
                  />
                  <ellipse
                    fill="#025c82"
                    cx="520.14"
                    cy="707.492"
                    rx="14.974"
                    ry="8.585"
                  />
                  <path
                    fill="#019cdc"
                    d="M356.674 508.862l-107.012-61.274 107.012-60.328 107.012 60.327z"
                  />
                  <path
                    fill="#B3B3B3"
                    d="M1062.142 692.93c-25.434-14.684-48.437-15.81-64.85-5.75-.69.424-12.687 7.73-13.354 8.192-14.432 10.014-11.936 22.36-12.012 48.968-.162 57.065 39.968 126.573 89.63 155.245 23.256 13.427 35.94 22.7 51.3 13.998 1.147-.65 11.31-6.95 12.334-7.53 1.688-.96 3.31-2.035 4.86-3.22 13.477-10.303 21.65-29.053 21.722-54.66.16-57.063-39.97-126.57-89.63-155.243"
                  />
                  <path
                    fill="#EDEDED"
                    d="M1049.94 700.386c-49.66-28.672-90.053-5.654-90.215 51.41-.162 57.066 39.968 126.574 89.63 155.246 49.66 28.672 90.054 5.654 90.216-51.41.162-57.066-39.968-126.574-89.63-155.246"
                  />
                  <path
                    fill="#EA0000"
                    d="M389.838 878.253c-2.386-1.378-4.327-.272-4.335 2.47s1.92 6.08 4.306 7.46c2.385 1.377 4.326.27 4.334-2.47s-1.92-6.082-4.306-7.46M335.838 846.253c-2.386-1.378-4.327-.272-4.335 2.47s1.92 6.08 4.306 7.46c2.385 1.377 4.326.27 4.334-2.47s-1.92-6.082-4.306-7.46"
                  />
                  <path
                    fill="#036790"
                    d="M355.864 508.8L247.59 446.62l.274.024v153.35l108 62.204z"
                  />
                  <path
                    fill="#042850"
                    d="M355.864 508.8l108.775-62.18.224.024v153.35l-109 62.204z"
                  />
                  <path
                    fill="#FFF"
                    d="M454.617 551.866l-.505-.863 239.752-140.22v11.205h-1v-9.462z"
                  />
                  <path
                    fill="#096dc1"
                    d="M697.666 423.787l.503.864L454.6 566.665l-.502-.864z"
                  />
                  <path
                    fill="#036790"
                    d="M402.864 553.42l31.012-17.772-.012.007v81.727l-31 17.78z"
                  />
                  <path
                    fill="#0a64d3"
                    d="M402.864 600.113v35.302l38.75-13.927-8.194-3.946z"
                  />
                  <ellipse
                    fill="#B3B3B3"
                    cx="301.372"
                    cy="560.68"
                    rx="12.452"
                    ry="13.209"
                  />
                  <path
                    fill="#B3B3B3"
                    d="M247.742 529.41H267.6v16.745h-19.858z"
                  />
                  <defs>
                    <path
                      id="SVGID_1_"
                      d="M257.533 545.702l.17-59.572 87.68 50.622-.17 59.572z"
                    />
                  </defs>
                  <clipPath id="SVGID_2_">
                    <use xlinkHref="#SVGID_1_" overflow="visible" />
                  </clipPath>
                  <g clipPath="url(#SVGID_2_)">
                    <path
                      fill="#B3B3B3"
                      d="M276.088 532.81c-1.376-.793-2.747-2.203-3.773-4.02-2.01-3.565-1.942-7.354.152-8.467 1.023-.54 2.34-.342 3.652.416 1.375.793 2.746 2.203 3.772 4.025 2.01 3.564 1.942 7.346-.152 8.46-1.022.54-2.34.343-3.652-.414m-1.657-28.3l-1.508 6.823c-1.067-.285-2.128-.413-3.1-.3l-5.543-7.623-2.518 1.34 3.716 8.84c-.565.804-.94 1.845-1.21 2.923l-6.588-2.406-.07 3.965 6.7 5.55c.284 1.398.74 2.838 1.324 4.292l-3.778 4.124 2.412 4.28 5.758-.886c.98 1.213 1.99 2.302 3.067 3.24l1.185 8.253 3.48 2.075 1.483-6.86c1.075.29 2.09.34 3.064.226l5.46 7.473 2.51-1.337-3.627-8.7c.565-.805 1.028-1.692 1.3-2.77l6.587 2.4.075-3.97-6.68-5.56c-.285-1.4-.71-2.857-1.293-4.31l3.85-4.165-2.413-4.273-5.822.923c-.98-1.213-2.066-2.28-3.137-3.208l-1.192-8.272-3.492-2.087"
                    />
                    <path
                      fill="#B3B3B3"
                      d="M319.358 560.317c-2.953-1.705-5.756-5.316-6.983-9.347-1.64-5.393.168-9.493 4.036-9.163.98.084 1.996.443 2.995 1.02 2.956 1.706 5.76 5.318 6.985 9.35 1.635 5.39-.168 9.5-4.042 9.158-.977-.084-1.992-.442-2.99-1.018m7.305-34.373l-5.473 6.393c-.56-.387-1.123-.745-1.69-1.07-1.047-.606-2.103-1.106-3.157-1.5l-5.478-12.348-4.642-.396 1.986 12.346c-1.275.455-2.377 1.208-3.3 2.188l-9.534-7.517-1.892 4.295 8.282 11.057c-.165 1.742-.106 3.65.176 5.68l-8 1.715 1.972 6.48 9.737 3.292c1.038 2.067 2.24 4.018 3.56 5.838l-1.788 9.94 4.68 4.87 5.473-6.393c.56.387 1.123.745 1.69 1.07 1.047.606 2.103 1.106 3.157 1.5l5.47 12.337 4.65.406-1.987-12.346c1.274-.462 2.376-1.208 3.293-2.2l9.533 7.526 1.893-4.294-8.282-11.057c.166-1.742.1-3.653-.18-5.683l7.99-1.713-1.97-6.48-9.73-3.295c-1.037-2.06-2.233-4.016-3.546-5.83l1.78-9.952-4.67-4.86"
                    />
                  </g>
                  <path
                    fill="#B3B3B3"
                    d="M243.638 515.228l18.49-10.68 7.54 10.68-16.313 11.745-7.453-3.695zM273.122 558.152l18.49-10.68 7.54 10.68-14.878 8.898-7.453-3.695zM257.333 560.722l18.49-10.68-3.773-9.784-16.313 11.745.448-4.81zM324.604 568.124l20.234-11.688-5.47-6.296-16.51 8.443-2.376-.06z"
                  />
                  <path
                    fill="#B3B3B3"
                    d="M322.883 590.906l20.47-11.823-10.118-13.52-19.953 5.45 5.432 10.182z"
                  />
                  <path
                    fill="#B3B3B3"
                    d="M312.128 597.91l20.47-11.823-4.28-14.933-25.79 6.863 5.43 10.182z"
                  />
                  <path
                    fill="#B3B3B3"
                    d="M291.68 588.855l20.47-11.824-4.28-14.933-18.08 6.974 5.43 10.183zM253.827 516.623l20.612-11.934 1.65 10.05-12.594 25.518-6.078-14.893zM285.736 528.796l20.505-11.87 6.43 13.59-17.315 21.792-6.047-14.816z"
                  />
                  <path
                    fill="#B3B3B3"
                    d="M306.206 537.71l20.505-11.87 2.21 37.855-13.095-2.473-6.047-14.815zM237.153 525.868l20.612-11.933 1.65 10.05-1.886 17.658-13.585-9.64z"
                  />
                  <path
                    fill="#B3B3B3"
                    d="M256.02 534.987l19.803-18.062 18.85 30.95-27.592 13.554-7.47-17.7z"
                  />
                  <defs>
                    <path
                      id="SVGID_3_"
                      d="M237.013 557.447l.17-59.572 87.68 50.622-.17 59.572z"
                    />
                  </defs>
                  <clipPath id="SVGID_4_">
                    <use xlinkHref="#SVGID_3_" overflow="visible" />
                  </clipPath>
                  <g clipPath="url(#SVGID_4_)">
                    <path
                      fill="#E6E6E6"
                      d="M255.568 544.556c-1.376-.794-2.747-2.204-3.773-4.022-2.01-3.564-1.942-7.353.152-8.466 1.023-.54 2.34-.342 3.652.416 1.375.794 2.746 2.204 3.772 4.026 2.01 3.564 1.942 7.346-.152 8.46-1.022.54-2.34.343-3.652-.414m-1.657-28.3l-1.508 6.822c-1.067-.285-2.122-.41-3.1-.298l-5.543-7.624-2.512 1.343 3.716 8.84c-.57.8-.945 1.84-1.217 2.92l-6.587-2.407-.07 3.965 6.7 5.55c.29 1.402.747 2.84 1.324 4.292l-3.778 4.124 2.412 4.28 5.758-.886c.98 1.213 1.99 2.302 3.067 3.24l1.185 8.253 3.48 2.076 1.49-6.855c1.066.286 2.083.337 3.062.226l5.453 7.47 2.517-1.333-3.633-8.704c.565-.806 1.028-1.693 1.3-2.77l6.587 2.398.082-3.965-6.68-5.56c-.29-1.403-.715-2.86-1.292-4.31l3.85-4.165-2.413-4.273-5.828.92c-.98-1.214-2.066-2.28-3.137-3.21l-1.192-8.27-3.492-2.09"
                    />
                    <path
                      fill="#E6E6E6"
                      d="M298.844 572.065c-2.954-1.706-5.76-5.318-6.982-9.347-1.64-5.393.16-9.497 4.036-9.163.977.083 1.992.442 2.99 1.018 2.953 1.705 5.756 5.316 6.983 9.347 1.636 5.39-.167 9.5-4.035 9.163-.977-.083-1.993-.442-2.99-1.018m7.298-34.376l-5.473 6.392c-.56-.387-1.123-.745-1.69-1.07-1.047-.606-2.103-1.106-3.157-1.5l-5.478-12.348-4.642-.395 1.986 12.345c-1.275.455-2.377 1.208-3.3 2.188l-9.534-7.517-1.892 4.294 8.282 11.057c-.165 1.742-.106 3.65.182 5.683l-8.005 1.713 1.97 6.48 9.737 3.292c1.037 2.06 2.24 4.02 3.558 5.84l-1.787 9.94 4.68 4.87 5.474-6.394c.56.388 1.123.746 1.69 1.072 1.047.605 2.103 1.105 3.157 1.5l5.48 12.34 4.64.402-1.985-12.346c1.274-.462 2.376-1.208 3.3-2.195l9.527 7.52 1.892-4.293-8.282-11.057c.165-1.742.1-3.653-.182-5.683l7.992-1.713-1.97-6.48-9.73-3.296c-1.038-2.06-2.228-4.01-3.547-5.83l1.787-9.947-4.68-4.864"
                    />
                  </g>
                  <defs>
                    <path
                      id="SVGID_5_"
                      d="M1110.572 861.588l.02-7.403 19.167 11.066-.022 7.404z"
                    />
                  </defs>
                  <clipPath id="SVGID_6_">
                    <use xlinkHref="#SVGID_5_" overflow="visible" />
                  </clipPath>
                  <g clipPath="url(#SVGID_6_)">
                    <path
                      fill="#7F7F7F"
                      d="M1126.7 863.486l-13.056-7.538c-1.686-.973-3.056-.192-3.062 1.752v.374c-.007 1.944 1.355 4.303 3.04 5.276l13.058 7.538c1.686.973 3.063.196 3.068-1.75v-.373c.007-1.944-1.36-4.306-3.047-5.28"
                    />
                  </g>
                  <defs>
                    <path
                      id="SVGID_7_"
                      d="M966.733 768.83l.013-4.863 12.597 7.273-.014 4.864z"
                    />
                  </defs>
                  <clipPath id="SVGID_8_">
                    <use xlinkHref="#SVGID_7_" overflow="visible" />
                  </clipPath>
                  <g clipPath="url(#SVGID_8_)">
                    <path
                      fill="#7F7F7F"
                      d="M977.096 770.08l-8.394-4.952c-1.11-.64-1.837-.127-1.837 1.142v.25c0 1.276.83 2.83 1.942 3.47l8.307 4.952c1.11.64 1.75.127 1.75-1.15v-.25c0-1.268-.657-2.822-1.768-3.463"
                    />
                  </g>
                  <defs>
                    <path
                      id="SVGID_9_"
                      d="M1032.224 808.952l.22-77.56 5.625 3.246-.22 77.56z"
                    />
                  </defs>
                  <clipPath id="SVGID_10_">
                    <use xlinkHref="#SVGID_9_" overflow="visible" />
                  </clipPath>
                  <g clipPath="url(#SVGID_10_)">
                    <path
                      fill="#575757"
                      d="M1035.413 733.105l-.313-.18c-1.47-.85-2.66-.17-2.665 1.517l-.203 71.457c-.005 1.686 1.18 3.737 2.647 4.584l.312.18c1.47.85 2.66.17 2.665-1.518l.203-71.457c.005-1.687-1.178-3.737-2.647-4.585"
                    />
                  </g>
                  <defs>
                    <path
                      id="SVGID_11_"
                      d="M1032.306 890.354l.057-20.11 5.625 3.25-.057 20.108z"
                    />
                  </defs>
                  <clipPath id="SVGID_12_">
                    <use xlinkHref="#SVGID_11_" overflow="visible" />
                  </clipPath>
                  <g clipPath="url(#SVGID_12_)">
                    <path
                      fill="#7F7F7F"
                      d="M1035.332 871.96l-.313-.182c-1.47-.848-2.66-.17-2.666 1.52l-.04 14.004c-.005 1.68 1.18 3.738 2.647 4.585l.314.18c1.47.85 2.66.163 2.665-1.517l.04-14.005c.004-1.688-1.18-3.738-2.648-4.586"
                    />
                  </g>
                  <defs>
                    <path
                      id="SVGID_13_"
                      d="M1032.306 720.317l.057-20.11 5.625 3.25-.057 20.108z"
                    />
                  </defs>
                  <clipPath id="SVGID_14_">
                    <use xlinkHref="#SVGID_13_" overflow="visible" />
                  </clipPath>
                  <g clipPath="url(#SVGID_14_)">
                    <path
                      fill="#7F7F7F"
                      d="M1035.332 701.922l-.313-.18c-1.47-.85-2.66-.162-2.666 1.518l-.04 14.005c-.005 1.687 1.18 3.738 2.647 4.585l.314.18c1.47.85 2.66.17 2.665-1.517l.04-14.005c.004-1.68-1.18-3.738-2.648-4.586"
                    />
                  </g>
                  <path
                    fill="#575757"
                    d="M1036.248 801.32c-3.032-1.752-5.775-1.886-7.73-.686-.083.05-1.514.92-1.593.977-1.72 1.195-1.423 2.667-1.432 5.84-.02 6.802 4.765 15.09 10.686 18.507 2.772 1.6 4.284 2.706 6.115 1.67.137-.08 1.35-.83 1.47-.9.202-.113.396-.24.58-.383 1.608-1.228 2.582-3.464 2.59-6.516.018-6.804-4.767-15.09-10.687-18.51"
                  />
                  <path
                    fill="#B3B3B3"
                    d="M1034.793 802.208c-5.92-3.418-10.736-.674-10.756 6.13-.02 6.802 4.765 15.09 10.686 18.507s10.736.674 10.756-6.13c.018-6.802-4.766-15.09-10.687-18.507"
                  />
                  <path
                    fill="#FFF"
                    d="M627.864 950.362V835.988h1v112.626l14.43-8.488 149.765-87.612.504.864-149.764 87.61z"
                  />
                  <defs>
                    <path
                      id="SVGID_15_"
                      d="M808.423 877.58l-.2-70.188L869.3 772.13l.2 70.187z"
                    />
                  </defs>
                  <clipPath id="SVGID_16_">
                    <use xlinkHref="#SVGID_15_" overflow="visible" />
                  </clipPath>
                  <g clipPath="url(#SVGID_16_)">
                    <path
                      fill="#FFF"
                      d="M824.055 824.148l4.09-3.302.804-5.182-5.37-3.06c1.1-1.155 2.27-2.09 3.442-2.767 2.312-1.335 4.625-1.655 6.398-.65 2.473 1.41 3.225 5.04 2.252 9.18l19.735 11.247-.006.004.06.026c1.632.93 1.64 3.968.018 6.78-.81 1.404-1.876 2.488-2.943 3.103-1.066.616-2.134.763-2.95.298l-.06-.04v.007l-19.728-11.243c-.883.828-1.8 1.518-2.718 2.048-2.312 1.334-4.625 1.656-6.395.647-2.67-1.515-3.335-5.62-1.998-10.156l5.368 3.058m14.707-34.387c-16.862 9.736-30.493 33.347-30.438 52.73.055 19.376 13.775 27.195 30.637 17.46 16.87-9.74 30.494-33.347 30.44-52.722-.056-19.384-13.77-27.206-30.638-17.467"
                    />
                    <path
                      fill="#FFF"
                      d="M852.515 832.868c-.415.24-.83.66-1.144 1.206-.63 1.1-.626 2.272.01 2.64.316.182.732.124 1.147-.116.415-.24.83-.66 1.144-1.206.63-1.1.628-2.272-.006-2.64-.318-.182-.734-.124-1.15.116"
                    />
                  </g>
                  <path
                    fill="#EA0000"
                    d="M1007.838 827.253c-2.386-1.378-4.327-.272-4.335 2.47s1.92 6.08 4.306 7.46c2.385 1.377 4.326.27 4.334-2.47.008-2.743-1.92-6.082-4.306-7.46"
                  />
                  <path
                    fill="#EA0000"
                    d="M825.018 725.563l182.977 105.754-.5.865-182.977-105.754z"
                  />
                  <path
                    fill="#043650"
                    d="M628.4 818.576l380.903-218.1.16.087V617.7L628.4 835.888z"
                  />
                  <path
                    fill="#096dc1"
                    d="M520.864 714.988h-1v-28.715L489.37 668.23l43.5-24.915-50.315-29.655 14.32-8.658-33.794-19.193.495-.87 35.278 20.034-14.346 8.675 50.352 29.678-43.502 24.917 29.506 17.458z"
                  />
                  <path
                    fill="#CCC"
                    d="M407.915 427.07c-28.932 16.704-52.31 57.194-52.214 90.44.045 15.375 5.104 25.917 13.39 31.79.833.59 15.276 9.328 16.115 9.905 4.823 3.317 8.847-3.546 23.052-11.747 28.93-16.704 52.315-57.198 52.22-90.443-.037-13.352 6.433-18.336 0-24.622-1.27-1.243-12.933-7.502-14.4-8.437-9.585-6.114-23.147-5.555-38.162 3.114"
                  />
                  <path
                    fill="#575757"
                    d="M420.737 434.41c-28.932 16.705-52.31 57.195-52.214 90.44.094 33.245 23.624 46.654 52.556 29.95 28.93-16.704 52.314-57.198 52.22-90.443-.095-33.245-23.632-46.65-52.563-29.946"
                  />
                  <path
                    fill="#2760f2"
                    d="M543.348 191.58c-2.753 1.59-4.978 5.442-4.97 8.605.01 3.164 2.25 4.44 5.002 2.85s4.978-5.443 4.97-8.607c-.01-3.163-2.25-4.438-5.002-2.85"
                  />
                  <path
                    fill="#EA0000"
                    d="M527.348 200.99c-2.753 1.59-4.978 5.444-4.97 8.607.01 3.164 2.25 4.44 5.002 2.85s4.978-5.443 4.97-8.607c-.01-3.163-2.25-4.438-5.002-2.85"
                  />
                  <defs>
                    <path
                      id="SVGID_17_"
                      d="M395.24 529.344l-.054-18.537 47.28-27.297.053 18.536z"
                    />
                  </defs>
                  <clipPath id="SVGID_18_">
                    <use xlinkHref="#SVGID_17_" overflow="visible" />
                  </clipPath>
                  <g clipPath="url(#SVGID_18_)">
                    <path
                      fill="#2760f2"
                      d="M397.842 509.273c-1.205.696-2.33 2.56-2.614 4.44-.314 2.07.52 3.365 1.863 2.892l42.422-12.866c.13-.047.26-.108.39-.183 1.203-.694 2.325-2.562 2.61-4.43.313-2.077-.522-3.373-1.864-2.893l-42.42 12.86c-.13.045-.258.106-.386.18"
                    />
                  </g>
                  <defs>
                    <path
                      id="SVGID_19_"
                      d="M428.373 503.857l-.16-56.307 18.315-10.574.16 56.307z"
                    />
                  </defs>
                  <clipPath id="SVGID_20_">
                    <use xlinkHref="#SVGID_19_" overflow="visible" />
                  </clipPath>
                  <g clipPath="url(#SVGID_20_)">
                    <path
                      fill="#2760f2"
                      d="M444.446 438.178c-.925.534-1.778 1.71-2.07 2.944l-13.92 59.432c-.36 1.523.283 2.563 1.434 2.31.218-.045.44-.135.656-.26.923-.533 1.78-1.712 2.072-2.945l13.92-59.433c.354-1.52-.282-2.563-1.433-2.31-.22.045-.442.135-.66.26"
                    />
                  </g>
                  <path
                    fill="#CCC"
                    d="M430.332 484.4c-6.825 3.94-12.34 13.493-12.318 21.336.01 3.627 1.204 6.114 3.16 7.5.196.14 3.603 2.2 3.8 2.337 1.14.782 2.088-.836 5.44-2.77 6.824-3.942 12.34-13.495 12.32-21.337-.01-3.15 1.516-4.326 0-5.81-.3-.292-3.052-1.77-3.398-1.99-2.262-1.443-5.462-1.31-9.004.734"
                  />
                  <path
                    fill="#383838"
                    d="M433.357 486.132c-6.825 3.94-12.34 13.493-12.318 21.336.02 7.843 5.572 11.006 12.397 7.065 6.825-3.94 12.342-13.494 12.32-21.336s-5.575-11.006-12.4-7.065"
                  />
                  <path
                    fill="#0a64d3"
                    d="M1148.99 620.145l-138.198-79.13 138.198-77.91 138.197 77.908z"
                  />
                  <path
                    fill="#036790"
                    d="M1149.162 620.038l-138.17-79.588-.4.086v17.137l138.57 79.677z"
                  />
                  <path
                    fill="#043650"
                    d="M1148.21 620.038l138.897-79.588.16.086v17.137L1148.21 637.35z"
                  />
                  <path d="M1159.645 533.91v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.836 37.952-21.97v-5.35l-75.974-.904" />
                  <ellipse
                    fill="#424242"
                    cx="1197.598"
                    cy="532.747"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1159.645 519.753v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.835 37.952-21.97v-5.35l-75.974-.903" />
                  <ellipse
                    fill="#424242"
                    cx="1197.598"
                    cy="518.59"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1159.645 505.596v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.836 37.952-21.97v-5.35l-75.974-.904" />
                  <ellipse
                    fill="#424242"
                    cx="1197.598"
                    cy="504.433"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1159.645 491.44v4.18c0 12.137 16.94 21.977 37.952 21.977s37.952-9.836 37.952-21.97v-5.35l-75.974-.904" />
                  <ellipse
                    fill="#424242"
                    cx="1197.598"
                    cy="490.276"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1159.645 477.283v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.835 37.952-21.97v-5.35l-75.974-.903" />
                  <ellipse
                    fill="#575757"
                    cx="1197.598"
                    cy="476.12"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1159.645 477.283v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.835 37.952-21.97v-5.35l-75.974-.903" />
                  <ellipse
                    fill="#424242"
                    cx="1197.598"
                    cy="476.12"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1159.645 463.126v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.836 37.952-21.97v-5.35l-75.974-.904" />
                  <ellipse
                    fill="#424242"
                    cx="1197.598"
                    cy="461.963"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1159.645 448.97v4.18c0 12.137 16.94 21.977 37.952 21.977s37.952-9.836 37.952-21.97v-5.35l-75.974-.904" />
                  <ellipse
                    fill="#424242"
                    cx="1197.598"
                    cy="447.806"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1159.645 434.812v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.836 37.952-21.97v-5.35l-75.974-.904" />
                  <ellipse
                    fill="#424242"
                    cx="1197.598"
                    cy="433.649"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1159.645 420.655v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.836 37.952-21.97v-5.35l-75.974-.904" />
                  <ellipse
                    fill="#424242"
                    cx="1197.598"
                    cy="419.492"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1065.72 533.91v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.836 37.952-21.97v-5.35l-75.973-.904" />
                  <ellipse
                    fill="#424242"
                    cx="1103.672"
                    cy="532.747"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1065.72 519.753v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.835 37.952-21.97v-5.35l-75.973-.903" />
                  <ellipse
                    fill="#424242"
                    cx="1103.672"
                    cy="518.59"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1065.72 505.596v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.836 37.952-21.97v-5.35l-75.973-.904" />
                  <ellipse
                    fill="#424242"
                    cx="1103.672"
                    cy="504.433"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1065.72 491.44v4.18c0 12.137 16.94 21.977 37.952 21.977s37.952-9.836 37.952-21.97v-5.35l-75.973-.904" />
                  <ellipse
                    fill="#424242"
                    cx="1103.672"
                    cy="490.276"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1065.72 477.283v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.835 37.952-21.97v-5.35l-75.973-.903" />
                  <ellipse
                    fill="#575757"
                    cx="1103.672"
                    cy="476.12"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1065.72 477.283v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.835 37.952-21.97v-5.35l-75.973-.903" />
                  <ellipse
                    fill="#424242"
                    cx="1103.672"
                    cy="476.12"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1065.72 463.126v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.836 37.952-21.97v-5.35l-75.973-.904" />
                  <ellipse
                    fill="#424242"
                    cx="1103.672"
                    cy="461.963"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1065.72 448.97v4.18c0 12.137 16.94 21.977 37.952 21.977s37.952-9.836 37.952-21.97v-5.35l-75.973-.904" />
                  <ellipse
                    fill="#424242"
                    cx="1103.672"
                    cy="447.806"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1065.72 434.812v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.836 37.952-21.97v-5.35l-75.973-.904" />
                  <ellipse
                    fill="#424242"
                    cx="1103.672"
                    cy="433.649"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1065.72 420.655v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.836 37.952-21.97v-5.35l-75.973-.904" />
                  <ellipse
                    fill="#424242"
                    cx="1103.672"
                    cy="419.492"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1113.126 561.27v4.183c0 12.136 16.94 21.976 37.952 21.976s37.952-9.837 37.952-21.972v-5.35l-75.973-.903" />
                  <ellipse
                    fill="#575757"
                    cx="1151.078"
                    cy="560.108"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1113.126 547.114v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.836 37.952-21.97v-5.35l-75.973-.904" />
                  <ellipse
                    fill="#575757"
                    cx="1151.078"
                    cy="545.951"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1113.126 532.957v4.182c0 12.135 16.94 21.975 37.952 21.975s37.952-9.836 37.952-21.97v-5.35l-75.973-.904" />
                  <ellipse
                    fill="#575757"
                    cx="1151.078"
                    cy="531.794"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1113.126 518.8v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.836 37.952-21.97v-5.35l-75.973-.904" />
                  <ellipse
                    fill="#575757"
                    cx="1151.078"
                    cy="517.637"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1113.126 504.643v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.835 37.952-21.97v-5.35l-75.973-.903" />
                  <ellipse
                    fill="#575757"
                    cx="1151.078"
                    cy="503.48"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1113.126 504.643v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.835 37.952-21.97v-5.35l-75.973-.903" />
                  <ellipse
                    fill="#575757"
                    cx="1151.078"
                    cy="503.48"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1113.126 490.487v4.182c0 12.135 16.94 21.975 37.952 21.975s37.952-9.836 37.952-21.97v-5.35l-75.973-.904" />
                  <ellipse
                    fill="#575757"
                    cx="1151.078"
                    cy="489.324"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1113.126 476.33v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.836 37.952-21.97v-5.35l-75.973-.904" />
                  <ellipse
                    fill="#575757"
                    cx="1151.078"
                    cy="475.167"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1113.126 462.173v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.835 37.952-21.97v-5.35l-75.973-.903" />
                  <ellipse
                    fill="#575757"
                    cx="1151.078"
                    cy="461.01"
                    rx="38.048"
                    ry="21.974"
                  />
                  <path d="M1113.126 448.016v4.182c0 12.136 16.94 21.976 37.952 21.976s37.952-9.836 37.952-21.97v-5.35l-75.973-.904" />
                  <ellipse
                    fill="#575757"
                    cx="1151.078"
                    cy="446.853"
                    rx="38.048"
                    ry="21.974"
                  />
                  <ellipse
                    fill="#EDEDED"
                    cx="1151.772"
                    cy="445.944"
                    rx="7.283"
                    ry="4.206"
                  />
                  <path
                    fill="#EDEDED"
                    d="M1151.864 444.988h-1V360.7l35-20.504v-26.92l-80.002-46.21-117.213 66.763-.496-.87 117.712-67.05.248.145 80.75 46.644v28.07l-35 20.505z"
                  />
                  <path
                    fill="#036790"
                    d="M986.293 334.05l-.502 51.878-44.14-26.888.155-51.684z"
                  />
                  <path
                    fill="#043650"
                    d="M986.205 333.98l-.45 51.904.07.104 5.993-3.354.396-52.017z"
                  />
                  <path
                    fill="#0a64d3"
                    d="M986.437 334.396l-44.48-26.75-.052-.114 5.99-3.355 44.552 26.855z"
                  />
                  <ellipse
                    transform="rotate(60.76 963.867 346.738)"
                    fill="#043650"
                    cx="963.898"
                    cy="346.749"
                    rx="10.117"
                    ry="5.843"
                  />
                  <path
                    fill="#036790"
                    d="M330.07 372.894l-.503 51.88-44.14-26.89.154-51.683z"
                  />
                  <path
                    fill="#043650"
                    d="M329.98 372.826l-.448 51.902.07.105 5.992-3.354.397-52.018z"
                  />
                  <path
                    fill="#0a64d3"
                    d="M330.213 373.24l-44.48-26.75-.052-.113 5.993-3.355 44.55 26.855z"
                  />
                  <ellipse
                    transform="rotate(60.76 307.693 385.587)"
                    fill="#043650"
                    cx="307.703"
                    cy="385.599"
                    rx="10.117"
                    ry="5.843"
                  />
                  <g>
                    <path
                      fill="#EDEDED"
                      d="M968.878 344.122l.507.862-64.89 38.26-.507-.862z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#2760f2"
                      d="M139.864 535.988h-1V482.7l.248-.144s43.173-25.173 86.365-50.324c21.596-12.575 43.197-25.146 59.41-34.56 8.105-4.708 14.864-8.626 19.6-11.362 7.804-4.508 7.8-4.51 8.102-4.16l-.38.326.188.46c-2.156 1.002-165.11 96.01-172.534 100.34v52.712z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#0a64d3"
                      d="M140.773 758.412L1.467 681.25l137.08-79.862 139.288 75.94z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#036790"
                      d="M140.944 758.303L1.658 680.683l-.397.09.244 17.137 139.686 77.702z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#043650"
                      d="M139.993 758.316l137.753-81.55.162.083.244 17.135-137.914 81.64z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#B3B3B3"
                      d="M98.236 646l-41.44-22.953 40.777-23.757 41.436 22.59z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#CCC"
                      d="M98.287 645.96l-41.35-22.923.02.01.677 47.698 41.33 22.934z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#4C4C4C"
                      d="M98.287 645.96l40.68-24.087-.018.01.676 47.7-40.662 24.096z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#036790"
                      d="M180.45 644.835l-41.44-22.955 40.777-23.757 41.436 22.59z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#0a64d3"
                      d="M180.5 644.794l-41.348-22.924.02.01.676 47.7 41.33 22.933z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#0b305e"
                      d="M180.5 644.794l40.682-24.088-.02.01.678 47.7-40.662 24.097z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#036790"
                      d="M246.79 594.74l-17.66-9.783 17.378-10.124 17.658 9.627z"
                    />
                    <path
                      fill="#0a64d3"
                      d="M246.812 594.722l-17.62-9.77.008.005.288 20.327 17.613 9.773z"
                    />
                    <path
                      fill="#0b305e"
                      d="M246.812 594.722l17.337-10.265-.01.004.29 20.328-17.33 10.27z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#043650"
                      d="M138.478 574.412l-41.44-22.954 40.778-23.757 41.436 22.59z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#036790"
                      d="M138.53 574.37L97.18 551.45l.02.01.677 47.698 41.33 22.934z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#383838"
                      d="M138.53 574.37l40.68-24.086-.018.01.677 47.7-40.664 24.096z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#FFF"
                      d="M520.864 715.988h-1v-46.715L489.37 651.23l43.5-24.915-50.315-29.655L496.88 588l-33.802-19.442.5-.867 35.27 20.287-14.34 8.672 50.35 29.678-43.5 24.917 29.506 17.458z"
                    />
                  </g>
                  <g opacity=".4">
                    <path
                      fill="#096dc1"
                      d="M922.864 600.988v48l-223 128.486V483.988"
                    />
                  </g>
                  <g>
                    <defs>
                      <path
                        id="SVGID_21_"
                        d="M552.01 774.507l89.49-52.005 116.182 67.077-89.49 52.005z"
                      />
                    </defs>
                    <clipPath id="SVGID_22_">
                      <use xlinkHref="#SVGID_21_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_22_)">
                      <path
                        fill="#096dc1"
                        d="M718.133 766.746l-48.215-27.837-73.163 9.594-16.326 42.41 47.934 27.676"
                      />
                    </g>
                  </g>
                  <g>
                    <ellipse
                      fill="#043650"
                      cx="629.352"
                      cy="789.631"
                      rx="14.974"
                      ry="8.585"
                    />
                  </g>
                  <g>
                    <path
                      fill="#E6E6E6"
                      d="M914.317 396.336L700.44 273.938l-.204.048V484.58l214.08 122.448z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#575757"
                      d="M914.317 396.336L700.44 273.938l-.204.048v25.77l214.08 122.448z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#B3B3B3"
                      d="M914.317 421.913l8.005-4.633.082.043v185.06l-8.087 4.677z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#424242"
                      d="M914.317 396.224l8.005-4.633.082.044v25.688L914.317 422z"
                    />
                  </g>
                  <g>
                    <ellipse
                      fill="#036790"
                      cx="709.557"
                      cy="292.127"
                      rx="3.921"
                      ry="6.789"
                    />
                  </g>
                  <g>
                    <ellipse
                      fill="#096dc1"
                      cx="722.382"
                      cy="298.917"
                      rx="3.921"
                      ry="6.789"
                    />
                  </g>
                  <g>
                    <ellipse
                      fill="#F2F2F2"
                      cx="735.206"
                      cy="305.706"
                      rx="3.921"
                      ry="6.789"
                    />
                  </g>
                  <g>
                    <path
                      fill="#383838"
                      d="M708.443 269.034l-8.207 4.886 214.246 122.537 7.92-5.024z"
                    />
                  </g>
                  <g>
                    <defs>
                      <path
                        id="SVGID_23_"
                        d="M551.242 722.14l90.193-52.414L758.46 737.29l-90.194 52.415z"
                      />
                    </defs>
                    <clipPath id="SVGID_24_">
                      <use xlinkHref="#SVGID_23_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_24_)">
                      <path
                        fill="#043650"
                        d="M728.725 720.938l-58.963-34.042-72.584 9.526-16.2 42.07 58.96 34.043 72.58-9.522 16.207-42.075"
                      />
                      <path
                        fill="#043650"
                        d="M580.977 738.493l16.2-42.07 72.585-9.527 58.962 34.042-16.208 42.075-72.578 9.522-58.96-34.042m148.84-17.74L670.07 686.26l-73.423 9.635-.312.04-16.396 42.584-.064.154 59.748 34.495 73.43-9.633.305-.037 16.4-42.587.058-.16"
                      />
                    </g>
                  </g>
                  <g>
                    <defs>
                      <path
                        id="SVGID_25_"
                        d="M552.016 696.744l89.49-52.005 116.18 67.076-89.488 52.006z"
                      />
                    </defs>
                    <clipPath id="SVGID_26_">
                      <use xlinkHref="#SVGID_25_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_26_)">
                      <path
                        fill="#07549b"
                        d="M729.276 695.412l-59.36-34.27-73.155 9.6-16.332 42.406 59.358 34.27 73.157-9.6 16.333-42.406"
                      />
                    </g>
                  </g>
                  <g>
                    <defs>
                      <path
                        id="SVGID_27_"
                        d="M552.013 672.26l89.496-52.008 116.18 67.078-89.495 52.01z"
                      />
                    </defs>
                    <clipPath id="SVGID_28_">
                      <use xlinkHref="#SVGID_27_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_28_)">
                      <path
                        fill="#2760f2"
                        d="M729.28 670.926l-59.36-34.27-73.156 9.6-16.34 42.41 59.36 34.27 73.162-9.604 16.333-42.406"
                      />
                    </g>
                  </g>
                  <g>
                    <path
                      fill="#FFF"
                      d="M628.838 677.253c-2.386-1.378-4.327-.272-4.335 2.47s1.92 6.08 4.306 7.46c2.385 1.377 4.326.27 4.334-2.47.008-2.743-1.92-6.082-4.306-7.46"
                    />
                  </g>
                  <g>
                    <path fill="#FFF" d="M627.864 681.988h1v116h-1z" />
                  </g>
                  <g>
                    <path
                      fill="#FFF"
                      d="M639.727 640.267c.64.213 1.81 0 2.716 0h8.255c.8-2.397 1.758-4.953 2.61-7.35.266-.746.852-2.024.8-2.61-.054-.64-1.173-1.864-1.6-2.503-1.224-1.864-2.183-3.355-3.3-4.953-.534-.85-1.12-1.65-1.812-2.396h-11.184c-1.704 3.142-3.036 6.604-4.527 9.96 1.864 2.396 3.835 4.952 5.858 7.455.586.746 1.598 2.237 2.184 2.397z"
                    />
                    <path
                      fill="#FFF"
                      d="M672.32 622.053c-1.863 2.716-3.567 5.273-5.325 8.042-.586.905-1.012 1.917-1.704 2.716-1.01 1.12-2.502 2.185-3.834 3.037-1.385.96-3.036 1.598-4.527 2.397-3.037 1.598-6.286 3.09-9.055 4.74-1.172.692-2.237 1.544-3.41 2.237-5.698 3.57-10.81 7.883-15.87 12.25-2.024 1.76-4.048 3.463-5.752 5.433 1.438 1.278 2.663 2.823 4.314 4.314l1.49 1.33c.16 0 2.557-2.183 2.824-2.396 2.238-1.703 3.73-2.822 5.753-4.633.905-.852 1.758-1.917 2.716-2.503 1.543-.96 3.514-1.65 5.325-2.503.533-.265 1.172-.798 1.81-.585 0 1.278-.532 2.61-.904 3.835-2.61 8.308-4.9 18.268-6.71 27.748h11.344c-.053-1.49.746-2.876 1.225-4.314.958-2.823 1.916-5.7 2.928-8.575.533-1.44.852-2.93 1.49-4.208.054-.16-.106-.373.32-.32.8.692 1.013 1.81 1.492 2.716 1.065 2.29 2.077 4.58 3.142 7.03.213.48.586.96.692 1.33.266 1.013.16 2.238.213 3.303.107 1.013.32 2.025.107 3.037h9.853c-.16-3.835-.053-7.723-.32-10.865-.373-5.006-2.184-9.64-3.835-13.688-.586-1.438-.905-3.09-1.49-4.74-.747-2.184-1.545-4.474-1.918-7.456-.107-.96-.48-2.077-.32-2.716.213-1.118 1.97-1.864 2.823-2.716 1.172-1.225 2.29-2.982 3.622-4.527l1.916-2.13c.64-.747 1.438-1.332 1.917-2.025.533-.8.852-1.81 1.33-2.61 1.44-2.503 3.143-4.687 4.634-7.243-2.607-1.704-5.59-3.088-8.306-4.74z"
                    />
                  </g>
                  <g id="bar_chart_4_icon_7_" opacity=".4">
                    <defs>
                      <path
                        id="SVGID_29_"
                        d="M520.58 596.726l54.185-31.488 51.268 29.6-54.183 31.488z"
                      />
                    </defs>
                    <clipPath id="SVGID_30_">
                      <use xlinkHref="#SVGID_29_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_30_)">
                      <path
                        fill="#096dc1"
                        d="M626.033 594.838l-13.6-5.537v2.96l-34.1-.39-.39-7.118-35.295-.037.092 5h26.296l.398 7.342 42.9.298-.008 2.875 13.707-5.392m-25.456 14.483l-14.314-8.263-28.995 16.85 14.314 8.264 28.995-16.85m-27.18-5.454l-14.314-8.264-20.16 11.715 14.315 8.264 20.16-11.714m-24.973-6.9l-14.174-8.184-13.67 7.944 14.175 8.183 13.67-7.945"
                      />
                    </g>
                  </g>
                  <g id="bar_chart_4_icon_1_">
                    <defs>
                      <path
                        id="SVGID_31_"
                        d="M520.286 597.144l.175-61.685 50.465 29.134-.175 61.685z"
                      />
                    </defs>
                    <clipPath id="SVGID_32_">
                      <use xlinkHref="#SVGID_31_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_32_)">
                      <path
                        fill="#EDEDED"
                        d="M570.925 564.594l-11.422-4.324 2.507 4.372-17.228 9.05-6.22-10.38-17.518 9.91 4.283 7.337 13.03-7.426 6.41 10.704 21.507-11.67 2.43 4.24 2.22-11.814m-.342 28.52l-14.09-8.135-.095 33.013 14.09 8.135.095-33.014m-18.084-.36l-14.09-8.134-.066 22.948 14.09 8.135.066-22.948m-18.21-3.114l-13.958-8.057-.044 15.56 13.957 8.06.044-15.562"
                      />
                    </g>
                  </g>
                  <g>
                    <path fill="#043650" d="M451.864 540.988h13v55h-13z" />
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M815.56 418.8l-17.493-10.016 3.958-2.19 17.492 9.863z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#B3B3B3"
                      d="M815.58 418.783L798.13 408.78l.008.005.02 37.194 17.444 10.005z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#0a64d3"
                      d="M813.033 420.195l-13.204-7.566.006.002.014 27.1 13.197 7.57z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#575757"
                      d="M815.58 418.783l3.92-2.33-.008.004.02 37.194-3.912 2.335z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M841.15 450.662l-17.49-10.016 17.49-9.862 17.493 9.862z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#B3B3B3"
                      d="M841.173 450.645l-17.453-10.003.008.004v20.298l17.445 10.006z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#575757"
                      d="M841.173 450.645l17.453-10.003-.008.004v20.298l-17.445 10.006z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#575757"
                      d="M805.735 444.935c-1.015-.586-1.84-.116-1.844 1.05s.818 2.59 1.833 3.175c1.015.586 1.84.116 1.844-1.05s-.817-2.59-1.832-3.175"
                    />
                  </g>
                  <g>
                    <path
                      fill="#B3B3B3"
                      d="M809.41 500.953v28.618c0 4.067 5.675 7.364 12.715 7.364s12.715-3.295 12.715-7.36v-29.01l-25.453-.303"
                    />
                  </g>
                  <g>
                    <ellipse
                      fill="#CCC"
                      cx="822.126"
                      cy="500.606"
                      rx="12.747"
                      ry="7.362"
                    />
                  </g>
                  <g>
                    <ellipse
                      fill="#036790"
                      cx="822.126"
                      cy="500.182"
                      rx="9.074"
                      ry="5.241"
                    />
                  </g>
                  <g>
                    <path
                      fill="#0a64d3"
                      d="M822.126 497.593c4.218 0 7.764 1.663 8.78 3.915.192-.423.295-.868.295-1.326 0-2.894-4.062-5.24-9.073-5.24-5.012 0-9.074 2.345-9.074 5.24 0 .458.102.902.294 1.326 1.015-2.253 4.56-3.915 8.78-3.915z"
                    />
                  </g>
                  <g>
                    <defs>
                      <path
                        id="SVGID_33_"
                        d="M826.763 458.534l.04-14.424 10.46 6.038-.042 14.424z"
                      />
                    </defs>
                    <clipPath id="SVGID_34_">
                      <use xlinkHref="#SVGID_33_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_34_)">
                      <path
                        fill="#FFF"
                        d="M830.45 450.434l.005-1.805c.003-1 .707-1.4 1.576-.9.863.5 1.57 1.715 1.567 2.713l-.005 1.805-3.142-1.814m1.583-3.305c-1.156-.668-2.097-.132-2.1 1.196l-.006 1.805-2.088-1.204-1.077 9.608 10.458 6.038-1.017-10.817-2.088-1.205.005-1.805c.004-1.328-.932-2.95-2.087-3.616"
                      />
                    </g>
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M864.02 463.937l-17.49-10.016 17.49-9.86 17.493 9.86z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#B3B3B3"
                      d="M864.043 463.92l-17.453-10.003.008.004v20.3l17.445 10.005z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#575757"
                      d="M864.043 463.92l17.453-10.003-.008.004v20.3l-17.445 10.005z"
                    />
                  </g>
                  <g>
                    <defs>
                      <path
                        id="SVGID_35_"
                        d="M849.632 471.81l.04-14.425 10.46 6.038-.042 14.424z"
                      />
                    </defs>
                    <clipPath id="SVGID_36_">
                      <use xlinkHref="#SVGID_35_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_36_)">
                      <path
                        fill="#FFF"
                        d="M853.32 463.71l.004-1.806c.003-.998.714-1.396 1.576-.898.868.5 1.568 1.714 1.565 2.712l-.005 1.805-3.14-1.814m1.582-3.306c-1.156-.667-2.097-.13-2.1 1.197l-.006 1.806-2.088-1.205-1.076 9.61 10.458 6.037-1.018-10.817-2.088-1.205.005-1.805c.003-1.328-.933-2.95-2.088-3.616"
                      />
                    </g>
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M886.89 477.212l-17.49-10.016 17.49-9.86 17.493 9.86z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M858.42 504.736l-1.85-1.117 12.96-7.297 1.826 1.038z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M859.994 503.4l-1.892 1.096-74.578-42.692 1.822-1.05z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M745.033 482.625l-1.89 1.095-30.824-17.286 1.82-1.05z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#B3B3B3"
                      d="M886.913 477.195l-17.453-10.003.008.004v20.298l17.445 10.007z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#575757"
                      d="M886.913 477.195l17.453-10.003-.008.004v20.298L886.913 497.5z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M791.93 415.152l-11.42-6.54 3.852-2.15 11.42 6.44z"
                    />
                    <path
                      fill="#B3B3B3"
                      d="M791.945 415.14l-11.395-6.53.005.003v13.253l11.39 6.533z"
                    />
                    <path
                      fill="#575757"
                      d="M791.945 415.14l3.826-2.24-.004.002v13.253l-3.82 2.244z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M785.905 418.656l-11.42-6.54 3.85-2.15 11.422 6.44z"
                    />
                    <path
                      fill="#B3B3B3"
                      d="M785.92 418.645l-11.396-6.53.005.002v13.253l11.39 6.533z"
                    />
                    <path
                      fill="#575757"
                      d="M785.92 418.645l3.826-2.24h-.006v13.254l-3.82 2.243z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M779.88 422.16l-11.42-6.54 3.85-2.15 11.42 6.44z"
                    />
                    <path
                      fill="#B3B3B3"
                      d="M779.894 422.15l-11.395-6.532.004.003v13.253l11.39 6.534z"
                    />
                    <path
                      fill="#575757"
                      d="M779.894 422.15l3.826-2.242-.005.002v13.253l-3.82 2.244z"
                    />
                  </g>
                  <g>
                    <defs>
                      <path
                        id="SVGID_37_"
                        d="M872.5 485.084l.042-14.424L883 476.698l-.04 14.424z"
                      />
                    </defs>
                    <clipPath id="SVGID_38_">
                      <use xlinkHref="#SVGID_37_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_38_)">
                      <path
                        fill="#FFF"
                        d="M876.188 476.984l.005-1.805c.003-1 .714-1.397 1.576-.9.867.502 1.567 1.715 1.565 2.713l-.005 1.805-3.142-1.814m1.583-3.305c-1.155-.668-2.09-.128-2.094 1.2l-.005 1.805-2.093-1.21-1.076 9.61 10.46 6.037-1.02-10.817-2.087-1.205.005-1.805c.004-1.328-.932-2.95-2.087-3.616"
                      />
                    </g>
                  </g>
                  <g>
                    <defs>
                      <path
                        id="SVGID_39_"
                        d="M861 497.483l7.326-4.258 8.517 4.917-7.326 4.258z"
                      />
                    </defs>
                    <clipPath id="SVGID_40_">
                      <use xlinkHref="#SVGID_39_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_40_)">
                      <path
                        fill="#7F7F7F"
                        d="M872.585 495.684l-11.585 1.8 8.517 4.916 3.068-6.716"
                      />
                    </g>
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M836.737 490.476l-1.848-1.117 13.365-7.503 1.827 1.038z"
                    />
                  </g>
                  <g>
                    <defs>
                      <path
                        id="SVGID_41_"
                        d="M839.724 483.02l7.326-4.258 8.517 4.917-7.326 4.257z"
                      />
                    </defs>
                    <clipPath id="SVGID_42_">
                      <use xlinkHref="#SVGID_41_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_42_)">
                      <path
                        fill="#7F7F7F"
                        d="M851.31 481.22l-11.586 1.8 8.517 4.917 3.07-6.716"
                      />
                    </g>
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M814.062 477.904l-3.138-.4 14.78-8.412 1.827 1.038z"
                    />
                  </g>
                  <g>
                    <defs>
                      <path
                        id="SVGID_43_"
                        d="M817.175 470.255l7.333-4.26 8.517 4.916-7.332 4.262z"
                      />
                    </defs>
                    <clipPath id="SVGID_44_">
                      <use xlinkHref="#SVGID_43_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_44_)">
                      <path
                        fill="#7F7F7F"
                        d="M828.767 468.452l-11.592 1.803 8.518 4.917 3.074-6.72"
                      />
                    </g>
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M787.23 461.804l-3.138-.4 14.78-8.412 1.826 1.04z"
                    />
                  </g>
                  <g>
                    <defs>
                      <path
                        id="SVGID_45_"
                        d="M790.34 454.157l7.327-4.258 8.517 4.916-7.326 4.258z"
                      />
                    </defs>
                    <clipPath id="SVGID_46_">
                      <use xlinkHref="#SVGID_45_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_46_)">
                      <path
                        fill="#7F7F7F"
                        d="M801.926 452.358l-11.585 1.8 8.518 4.916 3.068-6.716"
                      />
                    </g>
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M839.017 509.35l-1.848-1.117 14.064-7.943 1.826 1.038z"
                    />
                  </g>
                  <g>
                    <ellipse
                      fill="#7F7F7F"
                      cx="839.753"
                      cy="507.506"
                      rx="3.65"
                      ry="2.092"
                    />
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M763.96 368.784l-45.773-26.416 4.288-2.372 45.774 26.248z"
                    />
                    <path
                      fill="#0a64d3"
                      d="M763.984 368.765l-45.73-26.4.008.004.02 40.294 45.723 26.405z"
                    />
                    <path
                      fill="#036790"
                      d="M763.984 368.745l-45.73-26.4.008.003.02 4.172 45.723 26.406z"
                    />
                    <path
                      fill="#575757"
                      d="M763.984 368.765l4.246-2.524-.01.005.022 40.295-4.237 2.53z"
                    />
                    <g id="network-2_13_">
                      <defs>
                        <path
                          id="SVGID_47_"
                          d="M729.91 383.43l.065-22.51 19.594 11.314-.065 22.51z"
                        />
                      </defs>
                      <clipPath id="SVGID_48_">
                        <use xlinkHref="#SVGID_47_" overflow="visible" />
                      </clipPath>
                      <g clipPath="url(#SVGID_48_)">
                        <path
                          fill="#FFF"
                          d="M743.01 386.425c.053.03.1.052.15.075.138.61.25 1.22.326 1.813-.633.017-1.317-.084-2.033-.32.577-.432 1.077-.966 1.488-1.61l.07.042m-7.934-12.055c.494.285.984.288 1.275-.074 2.367 2.358 4.354 5.4 5.656 8.585-.628.366-.625 1.522.006 2.54-.56.83-1.27 1.47-2.097 1.897-.067-.037-.135-.075-.202-.114-3.91-2.258-7.088-7.23-7.918-11.805.636-.875 1.443-1.51 2.384-1.893.266.388.582.683.896.865m-3.48-.814c-.007-.143-.02-.297-.02-.437.003-.808.1-1.523.27-2.176.244.126.488.257.734.4.33.19.666.4 1.02.643l.032.23c-.755.293-1.434.74-2.037 1.34m12.8 14.65c-.082-.54-.19-1.095-.32-1.65.735-.338.707-1.655-.05-2.732.478-1.906.51-4.26.018-6.838.154-.014.282-.08.384-.182 1.2 1.082 2.308 2.34 3.31 3.71.106.687.168 1.37.166 2.03-.01 3.17-1.396 5.175-3.508 5.66m-1.507-5.344c-1.397-3.458-3.6-6.898-6.317-9.57l-.03-.208c1.544.022 3.207.547 4.88 1.513.095.054.19.11.282.166.254.728.757 1.452 1.357 1.887l.005.004c.448 2.28.467 4.467.008 6.296l-.185-.085m.072-9.71c-.444-1.21-.997-2.427-1.64-3.628 2.705 2.165 4.94 5.608 5.966 9.066-.822-1.004-1.69-1.916-2.6-2.736-.08-.975-.838-2.188-1.714-2.694l-.012-.007m-10.786-3.17c1.216-2.758 4.16-3.513 7.595-1.53.89 1.45 1.653 2.984 2.244 4.552-.21.084-.365.267-.43.553l-.16-.094c-1.947-1.122-3.788-1.666-5.438-1.667-.268-.385-.582-.677-.893-.856-.493-.285-.98-.288-1.266.065-.43-.3-.825-.552-1.212-.775-.147-.086-.294-.167-.44-.246m7.6-3.4c-5.414-3.126-9.815-.626-9.832 5.596-.018 6.214 4.354 13.787 9.77 16.912 5.407 3.122 9.807.614 9.825-5.6.017-6.22-4.355-13.786-9.763-16.908"
                        />
                      </g>
                    </g>
                  </g>
                  <g id="network-2_11_">
                    <defs>
                      <path
                        id="SVGID_49_"
                        d="M802.82 433.394l.024-8.92 7.764 4.482-.025 8.92z"
                      />
                    </defs>
                    <clipPath id="SVGID_50_">
                      <use xlinkHref="#SVGID_49_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_50_)">
                      <path
                        fill="#FFF"
                        d="M807.393 435.205c.23-.168.43-.384.59-.637l.09.044c.056.246.094.48.125.72-.25.01-.518-.035-.805-.127m-2.524-5.4c.194.114.387.116.505-.027.937.938 1.72 2.14 2.235 3.4-.243.145-.245.6.003 1.008-.218.33-.5.586-.827.75l-.08-.046c-1.554-.897-2.814-2.866-3.136-4.677.25-.34.565-.6.942-.75.107.153.232.27.357.343m-1.38-.324l-.007-.172c0-.315.04-.6.105-.858.1.05.2.106.304.165.126.073.255.153.392.244l.013.096c-.302.113-.57.29-.808.526m5.073 5.81c-.038-.22-.076-.433-.132-.657.296-.13.284-.652-.015-1.082.188-.76.203-1.69.008-2.707l.154-.073c.472.427.912.923 1.307 1.467.044.275.07.54.068.804-.005 1.262-.557 2.053-1.39 2.248m-.6-2.118c-.553-1.377-1.426-2.733-2.504-3.796l-.013-.08c.61.004 1.268.215 1.93.597l.12.072c.096.283.3.57.536.743.177.903.188 1.77.007 2.494l-.076-.03m.03-3.848c-.177-.485-.393-.97-.647-1.44 1.072.854 1.957 2.217 2.362 3.59-.325-.392-.67-.76-1.027-1.077-.037-.393-.33-.867-.675-1.067l-.012-.007m-4.274-1.263c.483-1.088 1.648-1.393 3.007-.608.356.58.655 1.187.89 1.807-.083.033-.14.11-.167.22l-.04-.024c-.784-.452-1.517-.67-2.177-.668-.108-.156-.234-.274-.358-.346-.194-.112-.386-.112-.5.028-.18-.127-.345-.232-.507-.325-.05-.03-.1-.057-.15-.084m3.01-1.348c-2.144-1.24-3.887-.246-3.894 2.22s1.725 5.462 3.87 6.7c2.145 1.24 3.888.247 3.895-2.218.007-2.466-1.724-5.464-3.87-6.702"
                      />
                    </g>
                  </g>
                  <g>
                    <path
                      fill="#B3B3B3"
                      d="M748.7 463.866v28.618c0 4.066 5.674 7.363 12.714 7.363s12.715-3.295 12.715-7.36v-29.01l-25.454-.303"
                    />
                  </g>
                  <g>
                    <ellipse
                      fill="#CCC"
                      cx="761.414"
                      cy="463.52"
                      rx="12.747"
                      ry="7.362"
                    />
                  </g>
                  <g>
                    <ellipse
                      fill="#036790"
                      cx="761.414"
                      cy="463.095"
                      rx="9.074"
                      ry="5.241"
                    />
                  </g>
                  <g>
                    <path
                      fill="#0a64d3"
                      d="M761.414 460.506c4.22 0 7.764 1.663 8.78 3.915.192-.422.295-.867.295-1.325 0-2.894-4.064-5.24-9.075-5.24-5.012 0-9.074 2.345-9.074 5.24 0 .458.103.902.295 1.326 1.016-2.25 4.56-3.914 8.78-3.914z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#7F7F7F"
                      d="M713.983 467.39l-1.848-1.118 47.96-28.858 1.825 1.038z"
                    />
                  </g>
                  <g>
                    <defs>
                      <path
                        id="SVGID_51_"
                        d="M756.402 436.157l7.326-4.258 8.517 4.916-7.326 4.258z"
                      />
                    </defs>
                    <clipPath id="SVGID_52_">
                      <use xlinkHref="#SVGID_51_" overflow="visible" />
                    </clipPath>
                    <g clipPath="url(#SVGID_52_)">
                      <path
                        fill="#7F7F7F"
                        d="M767.987 434.358l-11.585 1.8 8.517 4.916 3.067-6.716"
                      />
                    </g>
                  </g>
                  <g>
                    <ellipse
                      fill="#7F7F7F"
                      cx="742.978"
                      cy="482.626"
                      rx="3.65"
                      ry="2.092"
                    />
                  </g>
                  <g id="connection-1_8_">
                    <path
                      fill="#FFF"
                      d="M758.454 492.137l2.115-6.345h-6.346l9.87-10.574-2.116 6.345h6.345l-9.87 10.574z"
                    />
                  </g>
                  <g id="connection-1_7_">
                    <path
                      fill="#FFF"
                      d="M819.294 530.05l2.115-6.344h-6.346l9.87-10.574-2.116 6.345h6.345l-9.87 10.574z"
                    />
                  </g>
                  <g id="cubo4">
                    <path
                      fill="#036790"
                      d="M1286.437 615.822l-10.563-5.85 10.394-6.057 10.562 5.76z"
                    />
                    <path
                      fill="#0a64d3"
                      d="M1286.45 615.812l-10.54-5.843h.006l.172 12.16 10.535 5.845z"
                    />
                    <path
                      fill="#0b305e"
                      d="M1286.45 615.812l10.37-6.14-.005.002.173 12.16-10.365 6.14z"
                    />
                  </g>
                  <g id="cubo3">
                    <path
                      fill="#036790"
                      d="M1259.535 654.773l-26.93-14.916 26.5-15.438 26.925 14.68z"
                    />
                    <path
                      fill="#0a64d3"
                      d="M1259.568 654.747l-26.87-14.897.014.006.44 30.996 26.856 14.903z"
                    />
                    <path
                      fill="#0b305e"
                      d="M1259.568 654.747l26.436-15.653-.013.006.44 30.996-26.422 15.66z"
                    />
                  </g>
                  <g id="cubo2">
                    <path
                      fill="#036790"
                      d="M48.966 561.282l-12.62-6.99 12.418-7.236 12.62 6.88z"
                    />
                    <path
                      fill="#0a64d3"
                      d="M48.982 561.27l-12.593-6.982.005.003.207 14.527 12.586 6.984z"
                    />
                    <path
                      fill="#0b305e"
                      d="M48.982 561.27l12.39-7.336-.007.003.206 14.526L49.19 575.8z"
                    />
                  </g>
                  <g id="cubo1">
                    <path
                      fill="#036790"
                      d="M24.646 601.012l-24.71-13.688 24.315-14.166 24.71 13.47z"
                    />
                    <path
                      fill="#0a64d3"
                      d="M24.676 600.988L.02 587.318l.012.006.404 28.443 24.644 13.675z"
                    />
                    <path
                      fill="#0b305e"
                      d="M24.676 600.988l24.258-14.364-.01.006.403 28.443-24.247 14.37z"
                    />
                  </g>
                  <g id="nube2">
                    <g id="cloud-17-icon_23_">
                      <defs>
                        <path
                          id="SVGID_53_"
                          d="M635.7 184.744l.206-72.048 100.628 58.098-.204 72.048z"
                        />
                      </defs>
                      <clipPath id="SVGID_54_">
                        <use xlinkHref="#SVGID_53_" overflow="visible" />
                      </clipPath>
                      <g clipPath="url(#SVGID_54_)">
                        <path
                          fill="#043650"
                          d="M694.592 187.866l7.373-4.194 7.312 12.672-4.488-2.59c-.157 10.1-7.427 14.156-16.315 9.025-3.863-2.23-7.606-5.987-10.54-10.57l-.198-.312 3.997-2.278.172.254c1.89 2.82 4.168 5.045 6.588 6.442 5.785 3.34 10.524.734 10.67-5.81l-4.572-2.64m-19.32-2.622l-7.317-12.676 4.488 2.59c.163-10.097 7.433-14.152 16.32-9.02 3.856 2.225 7.6 5.974 10.528 10.553l.205.317-4.003 2.274-.166-.25c-1.89-2.81-4.168-5.036-6.582-6.43-5.79-3.343-10.53-.738-10.677 5.806l4.57 2.64-7.364 4.198m20.865-37.773c-8.387-4.84-16.855-5.267-22.265 1.465-2.186-2.688-4.525-4.696-6.817-6.02-6.953-4.014-13.476-1.735-14.034 6.886-9.69-4.226-17.225.917-17.257 12.42-.035 12.436 8.715 27.592 19.537 33.84l61.427 35.466c10.827 6.252 19.63 1.23 19.664-11.206.03-10.058-5.68-21.88-13.59-29.348-1.166-18.302-13.82-36.085-26.666-43.5"
                        />
                      </g>
                    </g>
                    <path
                      fill="#043650"
                      d="M656.678 166.873l29.442-14.057 22.32 20.974 10.345 32.94-13.847 11.484-27.03-14.654-17.37-15.266z"
                    />
                    <g id="cloud-17-icon_19_">
                      <defs>
                        <path
                          id="SVGID_55_"
                          d="M630.015 186.65l.204-72.047 100.634 58.1-.204 72.05z"
                        />
                      </defs>
                      <clipPath id="SVGID_56_">
                        <use xlinkHref="#SVGID_55_" overflow="visible" />
                      </clipPath>
                      <g clipPath="url(#SVGID_56_)">
                        <path
                          fill="#EDEDED"
                          d="M690.45 149.377c-8.386-4.842-16.854-5.266-22.264 1.464-2.186-2.685-4.524-4.69-6.815-6.014-6.952-4.015-13.476-1.74-14.035 6.88-9.69-4.226-17.225.917-17.257 12.42-.035 12.436 8.715 27.592 19.537 33.84l61.433 35.47c10.822 6.247 19.63 1.228 19.665-11.207.03-10.06-5.687-21.883-13.596-29.345-1.166-18.307-13.82-36.09-26.667-43.508"
                        />
                      </g>
                    </g>
                  </g>
                  <g id="nube1">
                    <g id="cloud-17-icon_11_">
                      <defs>
                        <path
                          id="SVGID_57_"
                          d="M423.392 214.726l-.347-122.298 170.82-98.624.348 122.3z"
                        />
                      </defs>
                      <clipPath id="SVGID_58_">
                        <use xlinkHref="#SVGID_57_" overflow="visible" />
                      </clipPath>
                      <g clipPath="url(#SVGID_58_)">
                        <path
                          fill="#0a64d3"
                          d="M523.067 104.762l12.43-21.52 12.496 7.13-7.617 4.397c-.174 17.405-12.438 38.492-27.525 47.202-6.556 3.786-12.923 4.757-17.93 2.747l-.34-.136 6.747-11.684.288.098c3.226 1.062 7.106.373 11.205-1.994 9.826-5.673 17.82-19.363 18.005-30.72l-7.758 4.478m-32.718 33.374l-12.498-7.13 7.617-4.397c.173-17.407 12.43-38.483 27.518-47.193 6.557-3.786 12.917-4.76 17.924-2.757l.34.135-6.747 11.684-.288-.1c-3.226-1.054-7.1-.368-11.2 2-9.82 5.668-17.812 19.36-18.004 30.72l7.764-4.482-12.428 21.518m34.94-104.74c-14.237 8.22-28.565 24.07-37.653 46.048-3.727-.27-7.704.91-11.595 3.158-11.803 6.814-22.816 23.432-23.676 39.104-16.44 11.814-29.138 35.268-29.083 54.79.06 21.114 15.004 29.63 33.38 19.022l104.28-60.206c18.375-10.61 33.222-36.325 33.162-57.44-.048-17.07-9.826-25.895-23.273-23.055-2.152-28.682-23.736-34.01-45.54-21.42"
                        />
                      </g>
                    </g>
                    <path
                      fill="#0a64d3"
                      d="M431.21 196.672l15.643 7.878 18.24-12.41-11.877-5.992z"
                    />
                    <path
                      fill="#036790"
                      className="moving-svg"
                      d="M554.97 66.81l12.765 7.598 26.637-12.867-13.812-6.968zM468.567 151.44l40.065 14.95s36.3-10.622 38.625-12.96c2.324-2.34 39.528-25.635 38.137-31.198s-15.646-39.986-15.646-39.986L536.02 59.993l-25.034 23.934-31.29 28.233-11.13 39.28z"
                    />
                    <g id="cloud-17-icon_2_">
                      <defs>
                        <path
                          id="SVGID_59_"
                          d="M437.472 223.104l-.35-123.507L609.63 0l.35 123.507z"
                        />
                      </defs>
                      <clipPath id="SVGID_60_">
                        <use xlinkHref="#SVGID_59_" overflow="visible" />
                      </clipPath>
                      <g clipPath="url(#SVGID_60_)">
                        <path
                          fill="#EDEDED"
                          d="M538.13 112.058l12.55-21.737 12.624 7.203-7.7 4.446c-.174 17.574-12.552 38.86-27.792 47.658-6.62 3.823-13.052 4.81-18.103 2.78l-.347-.146 6.81-11.794.293.095c3.258 1.08 7.17.387 11.314-2.005 9.922-5.728 17.998-19.555 18.19-31.026l-7.84 4.526m-33.044 33.702l-12.62-7.198 7.695-4.442c.175-17.582 12.56-38.87 27.793-47.666 6.62-3.823 13.045-4.805 18.097-2.784l.346.138-6.81 11.802-.293-.095c-3.258-1.073-7.17-.372-11.307 2.016-9.922 5.73-17.992 19.552-18.183 31.023l7.84-4.527-12.557 21.734m35.292-105.778c-14.38 8.302-28.85 24.31-38.03 46.506-3.764-.272-7.78.92-11.71 3.19-11.92 6.88-23.042 23.66-23.906 39.49-16.606 11.925-29.425 35.61-29.37 55.324.06 21.327 15.153 29.927 33.713 19.21l105.31-60.8c18.553-10.71 33.546-36.68 33.486-58.007-.048-17.233-9.922-26.156-23.503-23.282-2.172-28.964-23.967-34.345-45.99-21.63"
                        />
                      </g>
                    </g>
                  </g>
                  <g id="service8">
                    <path
                      fill="#FFF"
                      d="M700.28 541.645c0-28.396-23.02-51.416-51.416-51.416s-51.416 23.02-51.416 51.415c0 25.802 19.007 47.16 43.783 50.85l9.834 17.03 10.408-18.026c22.3-5.624 38.808-25.81 38.808-49.855z"
                    />
                    <path
                      fill="#036790"
                      d="M652.257 544.258c0 .534-.432.966-.966.966h-25.945c-.534 0-.966-.432-.966-.966s.43-.966.965-.966h25.946c.535 0 .967.432.967.966zm-.966 4.83h-25.945c-.534 0-.966.432-.966.966s.43.966.965.966h25.946c.535 0 .967-.432.967-.966s-.432-.966-.966-.966zm-9.66 6.073h-16.284c-.534 0-.966.433-.966.967s.432.966.966.966h16.285c.535 0 .967-.432.967-.966s-.433-.966-.966-.966zm40.904-32.74v18.477c0 2.96-2.318 5.43-5 5.43h-2.957l-3.95 6.86c-.174.3-.493.492-.838.492s-.665-.197-.838-.496L665 546.328h-6.48v13.598c0 2.87-2.335 5.17-5.138 5.17h-18.14l-3.95 6.86c-.172.3-.49.492-.837.492s-.664-.196-.837-.495l-3.95-6.856h-2.96c-2.86 0-5.315-2.4-5.315-5.17v-18.48c0-2.823 2.456-5.33 5.316-5.33h18.972V522.42c0-2.717 2.196-4.797 5.18-4.797h30.672c2.867 0 5 2.035 5 4.796zm-25.945 19.028c0-1.826-1.498-3.4-3.206-3.4H622.71c-1.766 0-3.383 1.668-3.383 3.4v18.478c0 1.712 1.585 3.24 3.384 3.24h3.517c.345 0 .664.2.837.498l3.394 5.886 3.394-5.89c.173-.3.49-.495.837-.495h18.696c1.738 0 3.205-1.436 3.205-3.24V541.45zm24.012-19.03c0-1.72-1.236-2.864-3.066-2.864h-30.673c-1.64 0-3.246 1.004-3.246 2.865v13.695h9.768c2.756 0 5.137 2.46 5.137 5.332v2.948h7.04c.344 0 .663.2.836.5l3.394 5.885 3.393-5.89c.173-.3.492-.495.837-.495h3.516c1.802 0 3.066-1.794 3.066-3.5V522.42h-.002zm-5.573 2.105h-26.223c-.534 0-.966.432-.966.966 0 .533.433.965.967.965h26.222c.533 0 .965-.432.965-.966 0-.535-.433-.967-.966-.967zm0 6.072h-26.223c-.534 0-.966.432-.966.966 0 .535.433.967.967.967h26.222c.533 0 .965-.432.965-.966 0-.533-.433-.965-.966-.965zm0 5.797h-12.974c-.534 0-.966.432-.966.966s.432.966.966.966h12.973c.533 0 .965-.432.965-.966s-.433-.966-.966-.966z"
                    />
                  </g>
                  <g id="service7">
                    <path
                      fill="#FFF"
                      d="M507.28 700.645c0-28.396-23.02-51.416-51.416-51.416s-51.416 23.02-51.416 51.415c0 24.965 17.795 45.767 41.39 50.432l10.026 17.363 10.025-17.363c23.595-4.665 41.39-25.467 41.39-50.432z"
                    />
                    <path
                      fill="#036790"
                      d="M439.48 694.794c-.106 0-.212-.04-.293-.12l-1.313-1.314c-.162-.162-.162-.424 0-.585.162-.162.424-.162.586 0l1.02 1.02 3.295-3.295c.162-.162.424-.162.585 0 .162.162.162.424 0 .585l-3.588 3.588c-.08.08-.186.12-.292.12zm3.388-1.405c0-.23-.185-.415-.414-.415s-.414.185-.414.414c0 1.385-1.128 2.513-2.515 2.513-1.387 0-2.515-1.128-2.515-2.514 0-1.388 1.128-2.516 2.515-2.516.422 0 .84.106 1.207.308.2.11.452.036.562-.164.11-.2.037-.452-.164-.562-.49-.268-1.044-.41-1.606-.41-1.843 0-3.343 1.5-3.343 3.343s1.5 3.34 3.344 3.34c1.844.002 3.344-1.498 3.344-3.34zm-3.095 14.14l3.588-3.587c.163-.162.163-.424 0-.585-.16-.162-.423-.162-.584 0l-3.295 3.295-1.02-1.02c-.16-.162-.423-.162-.585 0s-.162.424 0 .585l1.313 1.313c.08.082.187.122.293.122s.212-.04.293-.12zm3.095-1.283c0-.23-.185-.414-.414-.414s-.414.185-.414.414c0 1.386-1.128 2.514-2.515 2.514-1.387 0-2.515-1.127-2.515-2.513 0-1.387 1.128-2.515 2.515-2.515.422 0 .84.106 1.207.308.2.11.452.036.562-.164.11-.2.037-.452-.164-.562-.49-.268-1.044-.41-1.606-.41-1.843 0-3.343 1.5-3.343 3.343s1.5 3.342 3.344 3.342 3.344-1.5 3.344-3.343zm-3.095 14.14l3.588-3.587c.163-.162.163-.424 0-.585-.16-.162-.423-.162-.584 0l-3.295 3.295-1.02-1.02c-.16-.163-.423-.163-.585 0s-.162.423 0 .584l1.313 1.313c.078.078.183.12.293.12.11.003.215-.04.293-.12zm3.095-1.283c0-.23-.185-.414-.414-.414s-.414.185-.414.414c0 1.387-1.128 2.515-2.515 2.515-1.387 0-2.515-1.13-2.515-2.516 0-1.386 1.128-2.514 2.515-2.514.422 0 .84.107 1.207.308.2.11.452.037.562-.164.11-.2.037-.452-.164-.562-.49-.268-1.044-.41-1.606-.41-1.843 0-3.343 1.5-3.343 3.342 0 1.843 1.5 3.343 3.344 3.343s3.344-1.5 3.344-3.343zm25.477-35.158c0-.534-.433-.966-.966-.966h-36.16c-.533 0-.965.432-.965.966v45.267c0 .534.433.966.966.966h36.16c.533 0 .965-.433.965-.967v-45.267zm-36.158.966h34.226v43.335h-34.226v-43.335zm43.06 38.26v-44.99c0-.534-.326-.998-.86-.998h-35.882c-.534 0-1.073.464-1.073.997v5.383c0 .533.432.966.966.966s.966-.434.966-.967v-4.448h33.95v43.06h-5.69c-.533 0-.965.432-.965.965 0 .533.43.966.965.966h6.762c.533 0 .86-.4.86-.934zm6.623-6.073v-44.992c0-.533-.325-.997-.86-.997h-35.88c-.535 0-1.074.465-1.074.998v5.382c0 .533.432.966.966.966s.966-.433.966-.966v-4.448h33.95v43.06h-5.69c-.533 0-.965.432-.965.965 0 .533.432.966.966.966h6.76c.535 0 .86-.4.86-.934zm-19.352-24.597c0-.23-.185-.414-.414-.414h-14.63c-.228 0-.413.184-.413.413s.186.414.415.414h14.63c.228 0 .413-.186.413-.414zm-5.796 2.76c0-.23-.185-.414-.414-.414h-8.833c-.23 0-.414.184-.414.413s.186.414.415.414h8.833c.228 0 .414-.185.414-.414zm5.796 9.384c0-.23-.185-.414-.414-.414h-14.63c-.228 0-.413.185-.413.414s.186.414.415.414h14.63c.228.002.413-.184.413-.413zm-5.796 2.76c0-.228-.185-.413-.414-.413h-8.833c-.23 0-.414.185-.414.414s.186.414.415.414h8.833c.228 0 .414-.186.414-.414zm5.796 10.213c0-.23-.185-.414-.414-.414h-14.63c-.228 0-.413.185-.413.414s.186.414.415.414h14.63c.228 0 .413-.185.413-.414zm-5.796 2.76c0-.23-.185-.414-.414-.414h-8.833c-.23 0-.414.185-.414.414s.186.414.415.414h8.833c.228 0 .414-.185.414-.414z"
                    />
                  </g>
                  <g id="service6">
                    <path
                      fill="#FFF"
                      d="M897.28 699.645c0-28.396-23.02-51.416-51.416-51.416s-51.416 23.02-51.416 51.415c0 24.946 17.768 45.736 41.337 50.422l10.08 17.458 10.078-17.458c23.57-4.686 41.337-25.476 41.337-50.422z"
                    />
                    <path
                      fill="#036790"
                      d="M871.29 681.52c0-.485-.394-.878-.88-.878h-49.43c-.486 0-.88.393-.88.878v39.144c0 .485.394.878.88.878h49.43c.486 0 .88-.393.88-.878V681.52zm-1.757.878v7.277h-47.676v-7.277h47.676zm-47.676 37.388v-28.354h47.676v28.354h-47.676zm4.05-31.646c1.248 0 2.264-1.016 2.264-2.264 0-1.248-1.015-2.264-2.263-2.264s-2.264 1.016-2.264 2.264c0 1.248 1.015 2.264 2.264 2.264zm0-2.77c.28 0 .508.227.508.507s-.228.508-.508.508-.508-.228-.508-.508.227-.508.507-.508zm6.28 2.77c1.247 0 2.263-1.016 2.263-2.264 0-1.248-1.016-2.264-2.264-2.264s-2.264 1.016-2.264 2.264c0 1.248 1.016 2.264 2.264 2.264zm0-2.77c.28 0 .507.227.507.507s-.228.508-.508.508-.507-.228-.507-.508.226-.508.506-.508zm6.28 2.77c1.247 0 2.263-1.016 2.263-2.264 0-1.248-1.016-2.264-2.264-2.264s-2.264 1.016-2.264 2.264c0 1.248 1.015 2.264 2.264 2.264zm0-2.77c.28 0 .507.227.507.507s-.228.508-.508.508-.507-.228-.507-.508.226-.508.506-.508zm18.293 11.577c.343.343.343.9 0 1.242l-11.417 11.416c-.172.17-.396.257-.62.257s-.45-.086-.622-.257l-4.178-4.18c-.343-.342-.343-.898 0-1.24s.9-.344 1.242 0l3.558 3.557 10.796-10.796c.343-.343.9-.343 1.242 0zm-1.698 8.884c0 5.624-4.575 10.2-10.198 10.2s-10.198-4.576-10.198-10.2c0-5.622 4.575-10.197 10.198-10.197 1.712 0 3.406.433 4.9 1.252.424.233.58.767.346 1.192-.233.425-.767.58-1.192.347-1.234-.677-2.636-1.035-4.054-1.035-4.654 0-8.44 3.786-8.44 8.44s3.786 8.44 8.44 8.44 8.44-3.786 8.44-8.44c0-.485.394-.878.88-.878.485 0 .878.394.878.88z"
                    />
                  </g>
                  <g id="service5">
                    <path
                      fill="#FFF"
                      d="M1119.284 614.648c0 24.94-17.76 45.74-41.34 50.42l-10.08 17.46-10.08-17.46c-23.58-4.68-41.34-25.48-41.34-50.42 0-28.4 23.02-51.42 51.42-51.42s51.42 23.02 51.42 51.42z"
                    />
                    <path
                      fill="#036790"
                      d="M1067.777 614.132v-14.586c0-.613-.497-1.11-1.11-1.11s-1.11.497-1.11 1.11v14.714c-.952.468-1.628 1.44-1.628 2.565 0 1.578 1.27 2.862 2.848 2.862s2.883-1.284 2.883-2.862c0-1.24-.93-2.298-1.883-2.693zm-1.013 3.335c-.354 0-.642-.288-.642-.642s.288-.642.642-.642.642.288.642.642-.288.642-.642.642zm20.677-22.333c.79-1.38.602-3.17-.575-4.347-1.408-1.408-3.698-1.408-5.106 0-.02.018-.03.04-.048.057-3.266-1.886-6.92-3.173-10.807-3.712.115-.392.174-.8.174-1.216 0-2.38-1.937-4.315-4.316-4.315-2.38 0-4.315 1.937-4.315 4.316 0 .417.06.825.175 1.216-14.58 2.022-25.842 14.567-25.842 29.694 0 16.532 13.45 29.98 29.98 29.98s29.982-13.448 29.982-29.98c0-8.524-3.575-16.228-9.304-21.692zm-2.145-2.777c.333.333.46.793.383 1.224-.638-.52-1.298-1.014-1.978-1.48.52-.257 1.163-.175 1.595.257zm-20.625-6.442c0-1.155.94-2.094 2.094-2.094s2.094.94 2.094 2.095c0 .348-.09.684-.253.987-.61-.037-1.223-.058-1.84-.058-.62 0-1.235.02-1.845.058-.162-.302-.25-.637-.25-.987zm2.094 58.67c-15.307 0-27.76-12.453-27.76-27.76s12.453-27.76 27.76-27.76 27.76 12.453 27.76 27.76c0 15.307-12.453 27.76-27.76 27.76zm0-52.877c-13.85 0-25.117 11.268-25.117 25.117s11.268 25.117 25.117 25.117c13.85 0 25.118-11.268 25.118-25.117s-11.268-25.117-25.118-25.117zm0 48.014c-12.625 0-22.897-10.27-22.897-22.897s10.27-22.897 22.897-22.897c12.625 0 22.897 10.27 22.897 22.897s-10.27 22.897-22.896 22.897z"
                    />
                  </g>
                  <g id="service4">
                    <path
                      fill="#FFF"
                      d="M1242.28 226.645c0-28.396-23.02-51.416-51.416-51.416s-51.416 23.02-51.416 51.415c0 24.946 17.768 45.736 41.337 50.422l10.08 17.458 10.078-17.458c23.57-4.686 41.337-25.476 41.337-50.422z"
                    />
                    <path
                      fill="#036790"
                      d="M1221.027 217.81v-8.183c0-.27-.072-.52-.22-.722-1.157-6.405-16.006-9.85-30.022-9.85-7.84 0-15.224 1.002-20.798 2.823-7.69 2.512-9.237 5.647-9.237 7.835 0 .328-.18.65.17.963v7.09c0 1.07.325 2.368 1.623 3.71-1.188 1.182-1.76 2.46-1.76 3.807 0 .328-.214.65.136.963v6.553c0 1.07.325 2.367 1.623 3.71-1.188 1.18-1.76 2.458-1.76 3.806 0 .328-.214.65.136.963v6.552c0 2.188 1.552 5.325 9.254 7.846 5.587 1.828 12.93 2.835 20.768 2.835 14.61 0 30.086-3.728 30.086-10.636v-7.6c0-.27-.07-.517-.22-.72-.173-1.008-.707-1.973-1.574-2.883 1.155-1.14 1.794-2.42 1.794-3.83v-7.734c0-.29-.086-.552-.254-.762-.202-.945-.724-1.85-1.54-2.707 1.154-1.14 1.793-2.418 1.793-3.83zM1190.91 226c-7.588 0-14.638-.963-19.986-2.713-4.78-1.564-7.56-3.628-7.56-5.52v-3.552c4.893 4.025 16.47 6.156 27.493 6.156 7.84 0 15.178-1.002 20.752-2.823 3.4-1.11 5.572-2.344 6.97-3.563v3.827c0 3.875-11.353 8.19-27.67 8.19zm0 15.035c-7.588 0-14.638-.964-19.986-2.714-4.78-1.563-7.56-3.627-7.56-5.52v-3.014c4.893 4.025 16.47 6.156 27.493 6.156 7.84 0 15.178-1.003 20.752-2.824 3.4-1.11 5.572-2.344 6.97-3.563v3.29c0 3.874-11.353 8.19-27.67 8.19zm-.116-39.534c16.3 0 27.66 4.33 27.66 8.213s-11.297 8.212-27.597 8.212c-15.428 0-26.444-3.877-27.493-7.585v-.713c0-.12-.085-.23-.117-.34.79-3.768 11.84-7.786 27.547-7.786zm.115 54.568c-7.588 0-14.638-.964-19.986-2.714-4.78-1.564-7.56-3.628-7.56-5.52v-3.015c4.893 4.024 16.47 6.155 27.493 6.155 7.84 0 15.178-1.003 20.752-2.824 3.4-1.11 5.572-2.343 6.97-3.562v3.29c0 3.874-11.353 8.19-27.67 8.19zm27.543-15.75c0 3.883-11.296 8.21-27.596 8.21-15.428 0-26.444-3.876-27.493-7.584v-.665c0-.125-.087-.243-.122-.356.124-.61.5-1.233 1.188-1.864 1.37.89 3.204 1.77 5.695 2.586 5.587 1.83 12.973 2.836 20.81 2.836 10.23 0 20.907-1.828 26.39-5.296.75.724 1.128 1.44 1.128 2.13zm0-15.035c0 3.884-11.296 8.212-27.596 8.212-15.428 0-26.444-3.877-27.493-7.586v-.8c0-.103-.08-.2-.103-.296.142-.585.51-1.184 1.17-1.79 1.37.892 3.204 1.772 5.695 2.587 5.587 1.83 12.973 2.837 20.81 2.837 10.23 0 20.907-1.828 26.39-5.296.75.727 1.128 1.443 1.128 2.133z"
                    />
                  </g>
                  <g id="service3">
                    <path
                      fill="#FFF"
                      d="M902.28 266.276c0-28.396-23.02-51.416-51.416-51.416s-51.416 23.02-51.416 51.416c0 24.863 17.647 45.602 41.1 50.38l10.316 17.868 10.317-17.87c23.453-4.776 41.1-25.515 41.1-50.378z"
                    />
                    <path
                      fill="#036790"
                      d="M883.373 242.14c0-3.02-2.457-5.495-5.476-5.495-2.413 0-4.463 1.463-5.19 3.724h-48.97c-.625 0-1.13.542-1.13 1.166v30.95c-2.26.558-4.25 2.734-4.25 5.332s1.99 4.774 4.25 5.332v12.642c0 .624.505 1.094 1.13 1.094h53.932c.623 0 1.13-.47 1.13-1.094v-48.257c2.583-.433 4.573-2.684 4.573-5.396zm-40.744 34.723v-11.267c2.26-.485 3.88-2.297 4.22-4.558h7.08c.126 0 .244-.007.356-.044.314 2.245 1.907 4.074 4.168 4.585v11.283H842.63zm15.824 2.26v15.502H842.63v-15.502h15.824zm-29.23-2.26c-.123-.646-.384-1.37-.757-1.963l10.047-10.038c.558.356 1.208.625 1.854.76v11.24h-11.145zm-4.357-15.825h11.17c.123.97.418 1.584.857 2.238l-9.992 10c-.603-.41-1.39-.69-2.035-.834v-11.404zm48.585-15.73l-10.996 10.21c-.53-.31-1.096-.526-1.742-.644V242.63h11.733c.095.97.455 1.913 1.005 2.678zm-13.75 18.16c-1.772 0-3.214-1.442-3.214-3.215s1.442-3.215 3.215-3.215 3.215 1.442 3.215 3.215-1.443 3.215-3.215 3.215zm-1.248-8.542c-1.938.466-3.557 1.997-4.055 3.973-.144-.066-.3-.123-.468-.123h-7.21c-.532-1.938-2.154-3.428-4.092-3.868v-12.28h15.825v12.296zm-17.01 2.112c1.773 0 3.215 1.442 3.215 3.215s-1.443 3.215-3.216 3.215-3.215-1.442-3.215-3.215 1.44-3.215 3.214-3.215zm19.27 8.593c2.262-.425 4.048-2.33 4.396-4.592h11.43v15.825h-15.825V265.63zm15.825-6.853h-11.56c-.175-.646-.464-1.218-.844-1.744l10.992-10.188c.435.257 1.088.463 1.41.59v11.342zm-36.17-16.147v12.255c-1.94.407-3.662 1.955-4.204 3.893h-11.3V242.63h15.503zm-19.754 35.187c0-1.773 1.442-3.215 3.215-3.215s3.216 1.442 3.216 3.215-1.442 3.215-3.215 3.215c-1.772 0-3.214-1.442-3.214-3.215zm4.25 5.375c2.262-.4 3.75-2.13 4.267-4.068h11.236v15.502h-15.503v-11.434zm35.85 11.433v-15.502h15.824v15.502h-15.825zm17.18-49.27c-1.773 0-3.215-1.442-3.215-3.215s1.443-3.215 3.216-3.215 3.215 1.442 3.215 3.215c0 1.772-1.44 3.215-3.214 3.215z"
                    />
                  </g>
                  <g id="service2">
                    <path
                      fill="#FFF"
                      d="M472.28 334.645c0-28.396-23.02-51.416-51.416-51.416s-51.416 23.02-51.416 51.415c0 24.946 17.768 45.736 41.337 50.422l10.08 17.458 10.078-17.458c23.57-4.686 41.337-25.476 41.337-50.422z"
                    />
                    <path
                      fill="#036790"
                      d="M451.823 335.79c0 17.273-14.053 31.327-31.326 31.327s-31.327-14.053-31.327-31.327c0-16.772 13.25-30.507 29.83-31.29l-1.668-1.522c-.478-.435-.512-1.175-.076-1.653.435-.478 1.175-.512 1.653-.076l3.728 3.398c.23.21.366.5.38.81.015.31-.094.614-.303.843l-3.4 3.73c-.23.253-.546.382-.864.382-.28 0-.563-.1-.787-.305-.478-.435-.512-1.175-.076-1.653l1.47-1.614c-15.316.753-27.545 13.45-27.545 28.95 0 15.984 13.003 28.988 28.987 28.988 15.982 0 28.985-13.003 28.985-28.987 0-8.726-3.877-16.905-10.637-22.44-.5-.408-.573-1.146-.164-1.645.41-.5 1.147-.573 1.646-.164 7.303 5.98 11.493 14.82 11.493 24.25zm-32.567 16.337v4.346c0 .646.524 1.17 1.17 1.17s1.17-.524 1.17-1.17v-4.346c0-.646-.524-1.17-1.17-1.17s-1.17.524-1.17 1.17zm16.156-16.25c0 .646.524 1.17 1.17 1.17h4.346c.646 0 1.17-.524 1.17-1.17s-.524-1.17-1.17-1.17h-4.346c-.647 0-1.17.523-1.17 1.17zm-31.59-1.17h-4.346c-.646 0-1.17.524-1.17 1.17s.524 1.17 1.17 1.17h4.346c.646 0 1.17-.524 1.17-1.17s-.524-1.17-1.17-1.17zm30.112 16.32c.228.227.528.342.827.342s.6-.115.828-.344c.457-.457.457-1.198 0-1.655l-2.755-2.754c-.457-.457-1.198-.457-1.655 0s-.457 1.198 0 1.655l2.756 2.756zm-24.52-27.83l-2.756-2.756c-.457-.456-1.198-.456-1.655 0s-.457 1.2 0 1.656l2.755 2.755c.228.23.528.344.827.344s.6-.114.827-.343c.458-.456.458-1.197 0-1.654zm-3.584 28.172c.3 0 .6-.115.827-.344l2.755-2.755c.457-.456.457-1.197 0-1.654s-1.198-.457-1.655 0l-2.755 2.755c-.457.458-.457 1.2 0 1.656.23.228.53.343.828.343zm26.176-26.176c.3 0 .6-.114.827-.343l2.755-2.754c.457-.457.457-1.198 0-1.655s-1.198-.456-1.655 0l-2.755 2.756c-.457.457-.457 1.198 0 1.655.23.23.528.344.828.344zm-10.41-5.827v-4.013c0-.645-.524-1.17-1.17-1.17s-1.17.525-1.17 1.17V336.146c0 .308.093.603.31.822l5.544 5.625c.23.232.523.348.825.348.297 0 .59-.112.82-.338.46-.454.49-1.195.035-1.655l-5.194-5.283v-16.297z"
                    />
                  </g>
                  <g id="service1">
                    <path
                      fill="#FFF"
                      d="M191.28 400.645c0-28.396-23.02-51.416-51.416-51.416s-51.416 23.02-51.416 51.415c0 24.946 17.768 45.736 41.337 50.422l10.08 17.458 10.078-17.458c23.57-4.686 41.337-25.476 41.337-50.422z"
                    />
                    <path
                      fill="#036790"
                      d="M141.442 402.26c0 .988-.804 1.792-1.792 1.792s-1.792-.804-1.792-1.792.804-1.792 1.792-1.792 1.792.803 1.792 1.792zm28.27 13.654c0 3.4-2.767 6.167-6.167 6.167-1.8 0-3.42-.78-4.547-2.015l-4.798 2.796c-.19.11-.396.164-.6.164-.41 0-.81-.213-1.033-.594-.332-.57-.138-1.302.432-1.634l4.76-2.773c-.24-.66-.375-1.367-.375-2.11 0-.728.142-1.425.375-2.074l-13.312-7.65c-.89 1.074-2.135 1.84-3.503 2.12v15.55c1.368.27 2.52.995 3.4 2.006l4.904-2.88c.57-.333 1.296-.14 1.628.43s.137 1.303-.433 1.635l-4.955 2.887c.21.62.33 1.282.33 1.973 0 3.4-2.768 6.167-6.168 6.167-3.4 0-6.167-2.767-6.167-6.167 0-.69.12-1.352.33-1.973l-5.162-3.008c-.57-.333-.76-1.065-.427-1.635s1.07-.763 1.64-.43l5.187 3c.882-1.01 2.13-1.735 3.498-2.004v-15.55c-1.367-.28-2.71-1.047-3.6-2.12l-13.385 7.65c.233.65.362 1.345.362 2.074 0 .742-.14 1.45-.382 2.11l4.425 2.578c.57.332.763 1.064.43 1.634-.22.38-.62.594-1.033.594-.204 0-.41-.052-.6-.163l-4.464-2.6c-1.13 1.234-2.745 2.015-4.546 2.015-3.4 0-6.146-2.767-6.146-6.167 0-2.992 2.26-5.49 4.997-6.05v-5.898c0-.66.537-1.195 1.197-1.195s1.197.535 1.197 1.195v5.9c1.37.26 2.477.954 3.352 1.923l13.418-7.698c-.18-.58-.28-1.194-.28-1.83 0-.836.167-1.632.47-2.358l-13.634-7.824c-.872.953-1.956 1.634-3.324 1.894v5.24c0 .66-.537 1.194-1.197 1.194s-1.197-.535-1.197-1.195v-5.24c-2.736-.557-4.996-3.056-4.996-6.048 0-3.4 2.752-6.167 6.153-6.167 1.923 0 3.638.886 4.77 2.27l4.806-2.8c.57-.334 1.302-.14 1.634.43.332.57.14 1.302-.43 1.634l-4.883 2.846c.173.566.27 1.166.27 1.788 0 .743-.13 1.453-.373 2.113l13.775 7.873c.85-.853 1.852-1.458 3.22-1.7V380.32c-1.368-.267-2.592-.98-3.47-1.976l-4.92 2.844c-.19.11-.402.163-.606.163-.41 0-.814-.212-1.036-.593-.332-.57-.14-1.302.43-1.634l4.88-2.843c-.22-.63-.344-1.306-.344-2.01 0-3.402 2.767-6.168 6.167-6.168s6.167 2.767 6.167 6.167c0 .704-.124 1.378-.343 2.01l4.97 2.893c.57.332.764 1.064.432 1.634-.223.38-.62.593-1.03.593-.205 0-.404-.052-.594-.163l-4.936-2.896c-.88.997-2.006 1.71-3.374 1.977v15.894c1.368.292 2.71 1.112 3.604 2.252l13.317-8.16c-.308-.732-.484-1.536-.484-2.38 0-.62.092-1.22.264-1.787l-4.145-2.414c-.57-.33-.763-1.063-.43-1.633s1.062-.763 1.632-.43l4.066 2.368c1.132-1.384 2.85-2.27 4.775-2.27 3.4 0 6.167 2.767 6.167 6.167s-2.767 6.167-6.167 6.167c-1.697 0-3.237-.69-4.353-1.804l-13.608 8.312c.148.53.234 1.085.234 1.66 0 .637-.097 1.252-.278 1.83l13.434 7.7c1.13-1.25 2.758-2.043 4.57-2.043 3.4.002 6.168 2.768 6.168 6.17zm-9.945-27.992c0 2.083 1.695 3.778 3.778 3.778s3.778-1.695 3.778-3.778-1.695-3.778-3.778-3.778c-2.084 0-3.778 1.695-3.778 3.778zm-40.235 0c0-2.083-1.695-3.778-3.778-3.778s-3.778 1.695-3.778 3.778 1.695 3.778 3.778 3.778 3.778-1.694 3.778-3.778zm0 27.992c0-1.993-1.553-3.627-3.512-3.764-.086.02-.174.032-.266.032-.092 0-.18-.013-.266-.032-1.96.138-3.51 1.77-3.51 3.764 0 2.083 1.694 3.778 3.777 3.778 2.082 0 3.777-1.695 3.777-3.778zm20.117-37.868c2.082 0 3.777-1.695 3.777-3.778s-1.695-3.778-3.778-3.778-3.78 1.695-3.78 3.778 1.696 3.778 3.78 3.778zm.266 48.1c-.086.02-.174.03-.266.03s-.18-.012-.266-.03c-1.96.137-3.51 1.77-3.51 3.763 0 2.082 1.694 3.777 3.777 3.777s3.78-1.695 3.78-3.778c-.003-1.994-1.555-3.627-3.514-3.765zm3.51-23.886c0-2.083-1.694-3.778-3.777-3.778s-3.78 1.695-3.78 3.778 1.696 3.778 3.78 3.778c2.083 0 3.777-1.695 3.777-3.778zm23.896 13.654c0-2.083-1.695-3.778-3.778-3.778s-3.778 1.695-3.778 3.778 1.695 3.778 3.778 3.778c2.084 0 3.778-1.695 3.778-3.778z"
                    />
                  </g>
                </svg>
              </Col>
            </Row>
          </div>
        </section>
        <Footer style={{ textAlign: "center" }}>
          HRSol Attendance ©2021 Created by Citynow
        </Footer>
      </>
    );
  }
}

export default ErrorNotFoundPage;
